import ApiService from './../api/ApiService';
import Config from '../constants/Config';
import Urls from './../api/Urls';
import Hotel from './../models/Hotel';
import Reservation from './../models/Reservation';
import TagGroupDetail from './../models/TagGroupDetail';

import { HOTEL } from './../constants/Define';
import { getDummyData } from './../utils/commonUtils';
import RateCompare from 'models/RateCompare';

export function getAllHotels(params) {
    return new ApiService({
        baseURL: Config.API_HOTEL,
        endpoint: Urls.HOTEL_ALL,
        params: params,
        parser: hotelsAllDataParser,
    }).get();
}

export function getAllHotelsActive(params) {
    return new ApiService({
        baseURL: Config.API_HOTEL,
        endpoint: Urls.HOTEL_ALL_ACTIVE,
        params: params
    }).get();
}

export function getHotels(params) {
    return new ApiService({
        baseURL: Config.API_HOTEL,
        endpoint: Urls.HOTEL_LIST,
        params: params,
        parser: hotelsDataParser,
    }).get();
}

export function getHotelDetail(id) {
    return new ApiService({
        baseURL: Config.API_HOTEL,
        endpoint: Urls.HOTEL_DETAIL,
        endpointParams: { id },
        parser: (data) => new Hotel(data.hotel),
    }).get();
}

export function createHotelDetail(hotel) {
    return new ApiService({
        baseURL: Config.API_HOTEL,
        endpoint: Urls.HOTEL_CREATE,
        parser: (data) => new Hotel(data.hotel),
    }).post({hotel: hotel.export()});
}

export function updateHotelDetail(hotel) {
    return new ApiService({
        baseURL: Config.API_HOTEL,
        endpoint: Urls.HOTEL_DETAIL,
        endpointParams: { id: hotel.id },
        parser: (data) => new Hotel(data.hotel),
    }).put({hotel: hotel.export()});
}

export function getHotelBooking(productVariantIds=[]) {
    return new ApiService({
        baseURL: Config.API_HOTEL,
        endpoint: Urls.HOTEL_BOOKING_DETAIL,
        parser: (data) => (data.reservations || []).map(item => new Reservation(item)),
    }).post(productVariantIds);
}

export function createHotelTranslate(hotel) {
    return new ApiService({
        baseURL: Config.API_HOTEL,
        endpoint: Urls.HOTEL_TRANSLATE_CREATE,
    }).post(hotel.export(true).translate());
}

export function updateHotelTranslate(hotel) {
    return new ApiService({
        baseURL: Config.API_HOTEL,
        endpoint: Urls.HOTEL_TRANSLATE_UPDATE,
    }).put(hotel.export(true).translate());
}

export function deleteHotelTranslate(id) {
    return new ApiService({
        baseURL: Config.API_HOTEL,
        endpoint: Urls.HOTEL_TRANSLATE_DELETE,
        endpointParams: { id },
    }).delete();
}

export function getCrossSellBooking(productVariantIds=[]) {
    return new ApiService({
        baseURL: Config.API_HOTEL,
        endpoint: Urls.CROSSSELL_BOOKING_DETAIL,
        parser: (data) => (data.data.reservations || []).map(item => new Reservation(item)),
    }).post(productVariantIds);
}

export function getTagroupDetailSKU(id) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.HOTEL_TAGGROUP_DETAIL_SKU,
        endpointParams: { id },
        params: { //hard code load hotel
            groupType: 3,
            tagType: 2,
            skuType: 7
        },
        parser: (data) => (data.data || []).map(item => new TagGroupDetail(item))
    }).get();
}

export function updateTagroupDetailSKUActive(tagsGroup) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.HOTEL_TAGGROUP_DETAIL_SKU_ACTIVE,
    }).put(tagsGroup);
}

const hotelsDataParser = (data) => ({
    hotels: (data.hotels || []).map(item => new Hotel(item)),
    pageIndex: Math.floor(data.offset/data.limit) + 1,
    pageSize: data.limit,
    totalCount: data.total
});
const hotelsAllDataParser = (data) => {
    return (data || []).map(item => new Hotel(item))
};

const getHotelItem = (i) => new Hotel({
    id: i,
    name: 'Hotel name ' + (i + 1),
    code: `CODE${i}`,
    shortDescription: `Short Description ${i + 1}`,
    description: `Description ${i + 1}`,
    types: [(i % 4 == 0 ? HOTEL.TYPE.VILLA : i % 3 === 0 ? HOTEL.TYPE.CONDOTEL : i % 2 === 0 ? HOTEL.TYPE.RESORT : HOTEL.TYPE.APARTMENT)],
    address: `Address ${i + 1}`,
    province: 'Province 1',
    country: 'Việt Nam',
    locationId: i,
    lat: 10.7797855,
    lng: 106.6990189,
    star: i % 5 + 1,
    hotline: `09231443 ${i + 1}`,
    review: i + 10,
    refId: i,
    media: [{ url: 'placeimg.com/200/200/any', order: 0 }],
    isActive: i % 2 === 0,
});

const getDummyHotels = (pageSize = 10, pageIndex = 1) => {
    const result = getDummyData(pageSize, pageIndex, getHotelItem);
    return { ...result, hotels: result.data };
}

export function clearCache (params) {
    return new ApiService({
        baseURL: Config.API_HOTEL,
        endpoint: Urls.HOTEL_RESET_CACHE,
        params: params,
    }).get();
}

export function getRateCompare(data) {
    return new ApiService({
        baseURL: Config.API_HOTEL,
        endpoint: Urls.HOTEL_COMPARE_RATE,
        params: data,
        parser: (data) => new RateCompare(data.result),
    }).get();
}

export function createRateCompare(data) {
    return new ApiService({
        baseURL: Config.API_HOTEL,
        endpoint: Urls.HOTEL_COMPARE_RATE,
        parser: (data) => new RateCompare(data),
    }).post(data);
}

export function updateRateCompare (data) {
    const id = data.id;
    return new ApiService({
        baseURL: Config.API_HOTEL,
        endpoint: Urls.HOTEL_COMPARE_RATE_DETAIL,
        endpointParams: { id },
        parser: (data) => new RateCompare(data),
    }).put(data.dataRateCompare);
}

export function deleteRateCompare(id) {
    return new ApiService({
        baseURL: Config.API_HOTEL,
        endpoint: Urls.HOTEL_COMPARE_RATE_DETAIL,
        endpointParams: {id}
    }).delete()
}
